const AppName = "Learn nqilxʷcn with Sncəwips";
const Language = "WestBankOkanagan";
const Tribe = "West Bank";
// const FirebaseConfig = { // Old Config
//   apiKey: "AIzaSyBd0gmA7PhB2BhyHtaHQ52BsUa6fuz9484",
//   authDomain: "west-bank-d0d66.firebaseapp.com",
//   projectId: "west-bank-d0d66",
//   storageBucket: "west-bank-d0d66.firebasestorage.app",
//   messagingSenderId: "732292537276",
//   appId: "1:732292537276:web:daa0384a1c002aad07a9b9",
//   measurementId: "G-ZNSNMD83FG",
// };
const FirebaseConfig = { // TODO: Switch to this for new Canada server
  apiKey: "AIzaSyDOBZvZoEok1NF_AfsAZsx2Cgipinmy_Og",
  authDomain: "west-bank-ca.firebaseapp.com",
  projectId: "west-bank-ca",
  storageBucket: "west-bank-ca.firebasestorage.app",
  messagingSenderId: "510267740966",
  appId: "1:510267740966:web:dd15e117c29f53b9e067e7",
  measurementId: "G-ZLK9LZN87S",
};
const FilePath = "https://storage.googleapis.com/west-bank-media/";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "vocabData" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_GameFilterDataNew", nameToSave: "gameData" },
  { collection: "KZ_GoldStar", nameToSave: "goldStar" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
];
const ParamsToFindGame = [
  { data: "category", param: "unit" },
  { data: "target", param: "game-name" },
  { data: "gameType", param: "game-type" },
];

const PossibleGames = [
  "Bubble Pop",
  "Counting",
  "Good Guess",
  "Matching",
  "Whack-A-Mole",
  "Word To Image",
  "Wordless",
  // "Item Fall",
  // "Solve It",
];
const NumberDataCategory = "Numbers Math";

const BottomColor = "rgba(83, 90, 41, 1.0)";

const VersionNumber = "2.03.00007";

const Credits = {
  credits: [
    "Website created and designed through Native Teaching Aids LLC by Thomas Koefod and Spencer Kittle",
  ],
  links: [
    {
      link: "https://www.sncewips.com",
      image: "sncewips_logo.png",
      style: "tall",
    },
    {
      link: "https://www.nativeteachingaids.com",
      image: "ntalogo.png",
      style: "short",
    },
  ],
};

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};
